import { LocaleTerms } from '../en/terms'

const terms: LocaleTerms = {
  welcome: 'Selamat Datang',
  goodbye: 'Selamat Tinggal',
  thankYou: 'Terima Kasih',
  yes: 'Ya',
  no: 'Tidak',
  please: 'Sila',
  excuseMe: 'Maaf',
  help: 'Bantuan',
  goodMorning: 'Selamat Pagi',
  goodNight: 'Selamat Malam',
  howAreYou: 'Apa Khabar?',
  sorry: 'Maafkan saya',
  congratulations: 'Tahniah',
  yesPlease: 'Ya, Sila',
  noThankYou: 'Tidak, Terima Kasih',
  whatIsYourName: 'Siapa Nama Anda?',
  myNameIs: 'Nama saya',
  seeYouLater: 'Jumpa Lagi',
  goodAfternoon: 'Selamat Petang',
  goodEvening: 'Selamat Malam',
}

export default terms
